import type { CityConfig } from "../city-template/types";

export const meridianIDConfig: CityConfig = {
  city: "Meridian",
  state: "Idaho",
  stateAbbr: "ID",
  slug: "meridian-id",
  route: "/cities/meridian-id",
  title: "Emergency Passport Meridian, ID — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Meridian, Idaho — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Ada County, The Village at Meridian, Treasure Valley professionals, Boise suburbs. No Denver trip needed.",
  h1: "Emergency & Expedited Passport Services in Meridian, Idaho",
  heroSubtitle: "Treasure Valley tech professional heading to an international conference? Boise suburb family with a European vacation booked? West Ada School District educator traveling for an international exchange? We help Meridian residents — from The Village shoppers to Eagle Road commuters to Centennial High families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30-100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Meridian%20Idaho%20with%20The%20Village%20at%20Meridian%20outdoor%20shopping%20and%20entertainment%20complex%20as%20focal%20point%20with%20its%20iconic%20fountain%20and%20clock%20tower%2C%20the%20Treasure%20Valley%20stretching%20toward%20the%20Boise%20foothills%20under%20a%20dramatic%20sunset%20sky%2C%20suburban%20neighborhoods%20and%20tree-lined%20streets%20in%20this%20fast-growing%20Idaho%20city%2C%20the%20Boise%20River%20greenbelt%20in%20the%20distance%2C%20professional%20real%20estate%20photography%20with%20vibrant%20colors%20and%20crisp%20detail&width=1800&height=700&seq=meridian-id-hero-2026&orientation=landscape",
  heroImageAlt: "Meridian Idaho The Village at Meridian and Treasure Valley at sunset",
  geoPosition: "43.6121;-116.3915",
  geoPlacename: "Meridian, Idaho",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Nearest regional passport agency — located approximately 800 miles from Meridian via I-84 and I-25; a 12-hour drive or flight from Boise (BOI)",
  },
  nearbyCitiesZips: [
    { name: "Meridian", zips: "83642, 83646" },
    { name: "Boise", zips: "83701, 83702, 83709" },
    { name: "Eagle", zips: "83616" },
    { name: "Nampa", zips: "83651, 83686" },
    { name: "Kuna", zips: "83634" },
    { name: "Star", zips: "83669" },
    { name: "Garden City", zips: "83714" },
  ],
  benefits: [
    { icon: "ri-building-2-line", title: "Treasure Valley Business Hub", desc: "Meridian is one of the fastest-growing cities in America and a major employment center for the Boise metro area. From Micron Technology to Scentsy to Blue Cross of Idaho — Meridian professionals travel internationally for business, conferences, and supplier meetings on tight timelines." },
    { icon: "ri-flight-takeoff-line", title: "BOI Airport — 15 Minutes Away", desc: "Boise Airport is just 15 minutes from Meridian with direct flights to Seattle, Denver, Salt Lake City, Portland, Minneapolis, Phoenix, and more — all major international gateways. Meridian residents can be at their international connection within hours." },
    { icon: "ri-shopping-bag-line", title: "The Village at Meridian & Tourism Economy", desc: "The Village at Meridian is a premier shopping and entertainment destination drawing visitors from across the Northwest. Local tourism and hospitality professionals attend international travel expos and industry conferences." },
    { icon: "ri-home-heart-line", title: "Fastest-Growing City in Idaho", desc: "With over 120,000 residents and rapid population growth, Meridian's need for passport services grows every year. New residents, growing families, and relocating professionals all need reliable, fast passport processing." },
  ],
  internalLinks: [
    { name: "Fast passport services in Boise, ID", route: "/cities/boise" },
    { name: "Expedited services in Nampa, ID", route: "/cities/nampa" },
    { name: "Quick services in Eagle, ID", route: "/cities/boise" },
    { name: "Idaho passport services overview", route: "/states/idaho" },
  ],
  fpcOfficeAddress: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
  fpcOfficeNote: "Fast Passport Center serves Meridian via secure registered courier with direct access to State Department processing. Our registered couriers hand-deliver your documents — meaning Meridian residents get faster results without driving to Seattle. Ship from any UPS Store, FedEx Office, or post office in Ada County. BOI airport is just 15 minutes from Meridian for those who prefer to fly to Seattle.",
  fpcOfficeDistance: "Serving Meridian, Boise, Eagle, Nampa, Kuna, Star, and all Treasure Valley communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Meridian and the Treasure Valley. From The Village at Meridian to Eagle Road commercial corridor, from the West Ada School District to the Micron campus — we serve all of Meridian. Our courier service eliminates the need to drive 500 miles to Seattle or fly there for an agency appointment.",
  nearbyCitiesIntro: "We serve Meridian and all Treasure Valley communities including Boise, Eagle, Nampa, Kuna, and Star. Our service covers Ada County and the entire Boise metropolitan area.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Meridian as simple as possible — with the reliability Treasure Valley professionals, growing families, and Idaho's fastest-growing community need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee.",
  mistakesIntro: "Meridian's rapid growth, strong tech and business travel demand, and proximity to BOI airport create unique passport situations. Here are the most common mistakes we see from Treasure Valley travelers.",
  testimonialsIntro: "Meridian travelers — from Treasure Valley tech professionals to West Ada families to Village of Meridian visitors — trust us when international travel deadlines arrive and Seattle is simply too far.",
  faqIntro: "Have questions about expedited passports in Meridian, ID? Here are the most common ones we hear from Treasure Valley and Ada County travelers.",
  statePageRoute: "/states/idaho",
  statePageName: "Idaho",
  servicesIntro: "Whether you need a renewal before a Micron business trip to Asia, an emergency passport for a last-minute tech conference, or a first-time passport for your Meridian family's European vacation — Fast Passport Center handles it with reserved courier submission availability.",
  dmvWebsite: "https://itd.idaho.gov/dmv/",
  dmvLabel: "Idaho Transportation Department — DMV Services",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2-9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No Denver trip needed", "Ideal for Treasure Valley professionals and families", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3-5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service through post office", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1-2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "Denver agency is 800 miles from Meridian", "Impractical — 7.5-hour drive or costly last-minute flight"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Treasure Valley tech executive with a last-minute Asia trip? Micron engineer heading to Singapore this week? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Meridian travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Meridian residents renew fast — no agency visit required for most renewals. Perfect for Treasure Valley professionals, Ada County families, and Boise suburb residents.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Ada County residents through every step with clear instructions for the nearest acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms like DS-64. We guide you through everything needed so your business trip or family vacation isn't derailed.",
      bullets: ["DS-64 form guidance", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your Meridian family vacation stays on track.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so travel documents match reservations and IDs.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Meridian ID", description: "Urgent passport processing for Meridian Idaho Treasure Valley travelers." },
    { name: "Expedited Passport Renewal Meridian ID", description: "Fast passport renewal for Meridian residents." },
    { name: "First-Time Passport Meridian ID", description: "New passport application services for Meridian residents." },
    { name: "Child Passport Meridian ID", description: "Minor passport services for Meridian families." },
    { name: "Name Change Passport Meridian ID", description: "Name correction for Meridian residents." },
  ],
  testimonials: [
    {
      name: "Ryan P.",
      location: "Meridian — Micron Engineer",
      rating: 5,
      text: "Got called to fly to our Singapore fab on a Monday, flight on Friday. I checked my passport — expired 2 months ago. Fast Passport Center processed it in 3 business days. I was on the plane Friday morning. The Singapore trip was critical for our new product launch.",
      service: "Emergency Passport — Semiconductor Travel",
    },
    {
      name: "The Henderson Family",
      location: "Meridian",
      rating: 5,
      text: "We planned a family trip to Italy for spring break. We live in the Paramount subdivision. Two of us needed renewals, our twins needed first-time passports. Fast Passport Center managed all four in 7 days. The kids still talk about the Colosseum.",
      service: "Family Passports — European Vacation",
    },
    {
      name: "Jennifer S.",
      location: "Meridian — Healthcare Professional",
      rating: 5,
      text: "St. Luke's nurse joining a medical mission to Guatemala. The team had a spot open up with 2 weeks' notice. I had never needed a passport before. Fast Passport Center got me through the first-time application and I had my passport in 8 days. The mission was incredible.",
      service: "First-Time Passport — Medical Mission",
    },
    {
      name: "Brian K.",
      location: "Meridian",
      rating: 5,
      text: "Sales director at a tech company — had to fly to London for a critical client meeting with 6 days' notice. My renewal came back in 4 days. Closed a seven-figure deal. Would not have happened without Fast Passport Center.",
      service: "Expedited Passport — Business Travel",
    },
  ],
  facilities: [
    {
      id: "meridian-1",
      name: "Meridian Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1200 N Main St",
      city: "Meridian",
      state: "ID",
      zip: "83642",
      phone: "(208) 888-4411",
      hours: "Mon-Fri 9:00 AM - 4:00 PM (appointment required)",
      distance: "Central Meridian",
      website: "https://tools.usps.com/find-location.htm?location=1377560",
      websiteLabel: "USPS Location",
      notes: "Primary passport acceptance facility for Meridian. Passport photos available on-site. Very busy due to Meridian's rapid population growth — book appointments 3-4 weeks ahead during peak travel seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "meridian-2",
      name: "Ada County Clerk — Boise",
      type: "County Clerk Passport Acceptance",
      address: "200 W Front St",
      city: "Boise",
      state: "ID",
      zip: "83702",
      phone: "(208) 287-6840",
      hours: "Mon-Fri 8:00 AM - 5:00 PM",
      distance: "Boise — about 10 miles east of Meridian",
      website: "https://adacounty.id.gov/clerk/",
      websiteLabel: "Ada County Clerk",
      notes: "Full-service county clerk office with passport acceptance. Convenient for Meridian residents working in downtown Boise. Appointment recommended. Does not offer photo services.",
      icon: "ri-government-line",
    },
    {
      id: "meridian-3",
      name: "Boise Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "770 S 13th St",
      city: "Boise",
      state: "ID",
      zip: "83708",
      phone: "(208) 433-4310",
      hours: "Mon-Fri 9:00 AM - 4:30 PM (appointment required)",
      distance: "Boise — about 12 miles east of Meridian",
      website: "https://tools.usps.com/find-location.htm?location=1377540",
      websiteLabel: "USPS Location",
      notes: "Largest acceptance facility in the Treasure Valley. Full passport photo service. More appointment availability than Meridian — good backup when Meridian is booked.",
      icon: "ri-mail-line",
    },
    {
      id: "meridian-4",
      name: "Nampa Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "123 11th Ave S",
      city: "Nampa",
      state: "ID",
      zip: "83651",
      phone: "(208) 466-3881",
      hours: "Mon-Fri 9:00 AM - 4:00 PM (appointment required)",
      distance: "Nampa — about 8 miles west of Meridian",
      website: "https://tools.usps.com/find-location.htm?location=1377568",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility for western Ada and Canyon County residents. Passport photos available. About 10-minute drive from Meridian via I-84.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Denver Passport Agency, 800 miles from Meridian", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — 12-hour drive or costly flight to Denver", fpc: "Most Meridian travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission as registered courier" },
    { feature: "Practicality for Meridian", agency: "500-mile drive or costly flight — completely impractical", fpc: "Entirely remote — ship from Meridian, receive at your door" },
    { feature: "Cost vs Resellers", agency: "Government fees — plus travel costs and days off work", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "BOI Airport International Connection Rush",
      description: "Meridian residents are just 15 minutes from BOI. The proximity creates a false sense of security — travelers assume passport issues can be resolved quickly because the airport is close. Your passport must be valid at BOI check-in, not at your connecting airport. An expired passport means you don't board in Boise.",
    },
    {
      icon: "ri-error-warning-line",
      title: "New Resident Documentation Gaps",
      description: "Meridian is Idaho's fastest-growing city. New residents relocating from other states often discover their birth certificates, marriage licenses, or name-change documents are packed away or still in their previous state. Out-of-state vital records add weeks to the passport timeline.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Seattle Agency Trip Planning Fallacy",
      description: "Meridian residents sometimes plan to fly to Seattle for a passport agency appointment, assuming the 1-hour flight makes it easy. Agency appointments are for life-or-death emergencies only and book weeks in advance. Showing up without the right emergency documentation means a wasted trip.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date — whether a Micron business trip, Treasure Valley tech conference, or Meridian family vacation." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist — whether you're a tech professional, Ada County family, or new Meridian resident." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send documents using overnight shipping. Most Meridian clients ship from the Meridian Post Office on Main Street or the UPS Store at The Village." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Your documents arrive at our center. We submit through reserved agency slots — so Meridian travelers never need to drive 500 miles to Seattle." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives at Your Door", description: "Your passport is shipped directly to your Meridian address. No agency visit. No Seattle. Just your passport, on time." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Meridian, Idaho?", a: "We offer Meridian-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5-10 business days. Because the nearest regional passport agency is Seattle (500 miles away), our remote courier service is the most practical fast option for the Treasure Valley." },
    { q: "Do I need to visit a Meridian office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Meridian Post Office, Ada County Clerk in Boise, or Nampa Post Office), then ship documents overnight. We handle State Department submission and return your passport to your Meridian address." },
    { q: "Where can I get passport acceptance in Meridian?", a: "Meridian has passport acceptance at the Main Post Office (1200 N Main St). Nearby options include the Ada County Clerk in Boise (10 miles east), Boise Main Post Office (12 miles east), and Nampa Post Office (8 miles west)." },
    { q: "Can I get a passport photo in Meridian?", a: "Yes. The Meridian Main Post Office offers on-site passport photos. Additional locations include The UPS Store at The Village, Walmart on Overland Road, and Walgreens on Eagle Road. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How does BOI airport proximity help Meridian travelers?", a: "Boise Airport is just 15 minutes from Meridian with direct flights to Seattle, Denver, Salt Lake City, Portland, Minneapolis, and Phoenix — all major international gateways. Meridian residents can reach their international connection with a single short domestic flight. Your passport must be valid at BOI check-in." },
    { q: "What documents do Meridian applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent." },
  ],
  photoLocations: [
    { name: "Meridian Main Post Office", address: "1200 N Main St, Meridian, ID 83642", hours: "Mon-Fri 9 AM - 4 PM (photo service available)" },
    { name: "The UPS Store — The Village", address: "3597 E Monarch Sky Ln, Meridian, ID 83646", hours: "Mon-Fri 8 AM - 6 PM, Sat 9 AM - 2 PM" },
    { name: "Walmart Supercenter — Meridian", address: "4051 E Fairview Ave, Meridian, ID 83642", hours: "Daily 6 AM - 11 PM" },
    { name: "Walgreens — Eagle Road", address: "100 E Fairview Ave, Meridian, ID 83642", hours: "Daily 8 AM - 10 PM" },
  ],
  dmvLocations: [
    {
      name: "Ada County DMV — Meridian",
      address: "1769 N Lakes Pl, Meridian, ID 83646",
      hours: "Mon-Fri 8:00 AM - 5:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment strongly recommended due to Meridian's population growth.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "BOI",
      name: "Boise Airport (Boise Air Terminal)",
      distance: "About 15 minutes from Meridian via I-84",
      address: "3201 W Airport Way, Boise, ID 83705",
      note: "Primary airport for the Treasure Valley with direct flights to Seattle, Denver, Salt Lake City, Portland, Minneapolis, Phoenix, and more — all major international gateways. 15-minute drive from Meridian.",
      flightUrl: "https://www.iflyboise.com/",
      flightLabel: "Boise Airport Website",
      featured: true,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified Idaho birth certificates from Idaho Vital Records. Online, mail, or in-person options available for Ada County.",
      url: "https://healthandwelfare.idaho.gov/services-programs/birth-death-marriage-divorce",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Ada County Clerk. Certified copies for name changes and passport applications.",
      url: "https://adacounty.id.gov/clerk/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Ada County District Court. Required for name change passport corrections.",
      url: "https://adacounty.id.gov/courts/",
    },
  ],
};